import React from "react";

import ptBr from "../../../config/texts/pt-br";

import { FormFull } from "form-full";
import { validations } from "../../../utils";
import Styles from "../EsqueceuSenhaStyles";
import {
  ButtonContained,
  ButtonOutlined,
  ButtonText,
  DefaultLogo,
  InputEmail,
} from "../../../components";
interface PageProps {
  goBack: () => void;
  onSubmit: (data: any) => void;
  loading: boolean;
}
function StepEmail({ goBack, onSubmit, loading }: PageProps): JSX.Element {
  const texts = ptBr.forgetPassword;
  const [buttonDisabled, setButton] = React.useState(true);

  return (
    <FormFull onSubmit={onSubmit}>
      <Styles.Content>
        <Styles.Header>
          <DefaultLogo maxWidth={200} />
        </Styles.Header>
        <div>
          <Styles.Title>{texts.titleStepOne}</Styles.Title>
          <Styles.Subtitle> {texts.subTitle[0]}</Styles.Subtitle>
        </div>

        <Styles.InputBox>
          <InputEmail
            name="email"
            label={texts.user}
            required={texts.userMessage}
            placeholder="exemplo@email.com"
            validation={validations.isEmailValid}
            onChange={() => {
              setButton(false);
            }}
          />
        </Styles.InputBox>
        <div>
          <Styles.EnterButton
            name="continue"
            loading={loading}
            disabled={buttonDisabled || loading}
            feedback={true}
            action="submit"
            label={texts.continue[0]}
          />
          <Styles.BackButton onClick={goBack}>{texts.onBack}</Styles.BackButton>
        </div>
      </Styles.Content>
    </FormFull>
  );
}

export default StepEmail;
